module.exports = __webpack_public_path__ + "img/icon-sm.8ff8a36d.svg";